import React, { useEffect, useState } from "react";
import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarExport,
} from "@mui/x-data-grid";
import Switch from "@mui/material/Switch";
import IconButton from "@mui/material/Button";
import DeleteIcon from "@mui/icons-material/Delete";
import EmojiPeopleIcon from "@mui/icons-material/EmojiPeople";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import Stack from "@mui/material/Stack";
import Tooltip from "@mui/material/Tooltip";
import MuiLink from "@mui/material/Link";
import Divider from "@mui/material/Divider";
import { Link } from "react-router-dom";
import Confirm from "../Confirm";
import EventStore from "./../../stores/eventStore";
import { getEventData, deleteEvent } from "./../../api/event";
import { updateEvent } from "./../../api/event";
import moment from "moment";

const CustomToolbar = () => {
  return (
    <GridToolbarContainer>
      <GridToolbarExport
        printOptions={{ disableToolbarButton: true }}
        csvOptions={{
          fileName: "export",
          utf8WithBom: true,
        }}
      />
    </GridToolbarContainer>
  );
};

const TbEvent = () => {
  const { events, setEvents } = EventStore();
  const [open, setOpen] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  ///////
  const columns = [
    { field: "eventName", headerName: "กิจกรรม", width: 300 },
    { field: "organizer", headerName: "หน่วยงาน", width: 300 },
    {
      field: "eventLocation",
      headerName: "สถานที่จัดงาน",
      width: 150,
    },
    {
      field: "eventDate",
      headerName: "วันที่",
      width: 150,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => moment(params.row.eventDate).format("DD/MM/YYYY"),
    },
    {
      field: "eventOpen",
      filterable: false,
      headerName: "เปิด/ปิด",
      sortable: false,
      headerAlign: "center",
      align: "center",
      disableExport: true,
      renderCell: (params) => {
        let chk = false;
        if (params.row.eventOpen === "Y") {
          chk = true;
        }
        return (
          <Switch
            defaultChecked={chk}
            onChange={(v) => {
              onOff(params.row.eventId, v.target.checked);
            }}
          />
        );
      },
    },
    {
      field: "action",
      width: 150,
      headerName: "แก้ไข/ลบ",
      sortable: false,
      filterable: false,
      headerAlign: "center",
      align: "center",
      disableExport: true,
      renderCell: (params) => {
        const del = async (id) => {
          //let d = await deleteEvent(id);
          //getEventData(setEvents);
          setDeleteId(id);
          setOpen(true);
        };
        return (
          <Stack direction="row" spacing={1}>
            <Tooltip title="ผู้เข้าร่วมกิจกรรม">
              <MuiLink
                component={Link}
                to={`/event/${params.row.eventId}/member`}
              >
                <EmojiPeopleIcon fontSize="small" />
              </MuiLink>
            </Tooltip>
            <Divider orientation="vertical" variant="middle" flexItem />
            <Tooltip title={"แก้ไข"}>
              <MuiLink
                component={Link}
                to={`/event/${params.row.eventId}/edit`}
              >
                <BorderColorIcon fontSize="small" />
              </MuiLink>
            </Tooltip>
            <Divider orientation="vertical" variant="middle" flexItem />
            <Tooltip title="ลบ">
              <MuiLink
                component={Link}
                to={"#"}
                onClick={() => del(params.row.eventId)}
              >
                <DeleteIcon fontSize="small" />
              </MuiLink>
            </Tooltip>
          </Stack>
        );
      },
    },
  ];
  //////
  const confirmDelete = async (id) => {
    await deleteEvent(id);
    getEventData(setEvents);
    setOpen(false);
  };

  const onOff = async (id, status) => {
    let on = "N";
    if (status === true) {
      on = "Y";
    }
    await updateEvent(id, { eventOpen: on });
  };

  return (
    <div style={{ width: "100%" }}>
      <DataGrid
        getRowId={(row) => row.eventId}
        autoHeight
        rows={events}
        columns={columns}
        pageSize={5}
        rowsPerPageOptions={[5]}
        disableSelectionOnClick
        components={{
          Toolbar: CustomToolbar,
        }}
      />
      <Confirm
        title={"ลบข้อมูล"}
        desc="ยืนยันการลบข้อมูล"
        open={open}
        setOpen={setOpen}
        id={deleteId}
        confirmDelete={confirmDelete}
      />
    </div>
  );
};

export default TbEvent;
